






























































import Vue, {PropType} from 'vue';

export default Vue.extend({
    name: 'home-row',

    props: {
        title: { type: String as PropType<string>, required: true },
        img: { type: String as PropType<string>, required: true },
        side: { type: String as PropType<'right' | 'left'>, default: () => 'right' },
        to: { type: String as PropType<string>, required: true },
    },
});
